import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import LeaseDetails from './leaseDetails';
import TransectionDetails from './TransectionDetails';
import Deduction from './deduction';
import OtherDetails from './otherDetails';
import WindowedSelect from 'react-windowed-select';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import Invoices from './invoices';
import Receipts from './receipts';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const LeaseTermination = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const { currencyPrecision } = useCurrency();

    const [activeFY, setActiveFY] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false,]);
    const [proprtyList, setProperty] = useState([])
    const [loading, setloader] = useState(false)
    const [unitList, setUnitList] = useState([])
    const [leaseList, setLeaseList] = useState([])
    const [taxList, setTaxList] = useState([])
    const [deductionList, setDeductionList] = useState([])
    const [InvoiceList, setInvoiceList] = useState([])
    const [receiptDetails, setReceiptDetails] = useState([])
    const [managerList, setManagerList] = useState([])
    const [remarksList, setRemarksList] = useState([])
    const [reasonList, setReasonList] = useState([])
    const [leaseDetails, setLeaseDetails] = useState()
    const [UnitDetails, setUnitDetails] = useState()
    const [TransectionDetail, setTransectionDetails] = useState()
    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
        securityDeposit: 0,
    });
    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);
    const today = new Date();
    const totalDeductoin = deductionList?.reduce((sum, item) => sum + parseFloat(item.total || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const totalAmount = receiptDetails?.reduce((sum, item) => sum + parseFloat(item?.Amount || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const totalrent = UnitDetails?.reduce((sum, item) => sum + parseFloat(item?.Rent || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const totalInvoice = InvoiceList?.reduce((sum, item) => sum + parseFloat(item?.Rent || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData();
    }, [])
    const [transectionData, setTransectionData] = useState({
        transDate: formattedDate,
        NoticeDate: formattedDate,
        vacatingDate: formattedDate,
        vacationDate: formattedDate,
        returnDate: formattedDate,
        rentPerPeriod: '',
        securityDeposit: '',
        rentperStayedPeriod: '',
        totalDeduction: '',
        totalAmountRec: '',
        sdRefund: '',
        rentAmtBalance: '',
        totalReceiveable: '',
        vacatingReason: '',
        remarks: '',
        rentBalance: '',
        stayedRent: '',
        deductionTotal: '',
        calculatedDays: '',
        totalpayable: '',
        rentPeriodUnchange: '',
        dayesStayed: '',
    });
    useEffect(() => {
        if (totalDeductoin > 0) {
            setTransectionData((prev) => ({
                ...prev,
                totalDeduction: totalDeductoin || 0,
            }));
            let TotalDedcution = totalDeductoin
            let transecData = TransectionDetail
            let totalAmt = parseFloat(transectionData?.totalAmountRec)
            let RentBalance = transectionData?.rentperStayedPeriod - totalAmt
            handleSDRefund(transecData?.SecurityDeposit, TotalDedcution, RentBalance)
        }
    }, [totalDeductoin])
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'TerminationCreatePropertyNames,TerminationCreateLeaseNos,TerminationLeaseRemarks,TerminationPropetyManagerNames,TerminationReason');
            const res = await apiService.getApiParamater('TERMINATION_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.PropertyNames)
            setLeaseList(res?.data?.dropdowns?.LeaseNo)
            setManagerList(res?.data?.dropdowns?.TerminationPropetyManagerNames)
            setRemarksList(res?.data?.dropdowns?.TerminationLeaseRemarks)
            setReasonList(res?.data?.dropdowns?.TerminationReason)

            const duductoinParam = new URLSearchParams();
            duductoinParam.append('Action', 'GetTaxDetails');
            const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
            setTaxList(deductionRes?.data?.result?.data)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
        setTransectionData({
            transDate: formattedDate,
            NoticeDate: formattedDate,
            vacatingDate: formattedDate,
            vacationDate: formattedDate,
            returnDate: formattedDate,
            rentPerPeriod: '',
            securityDeposit: '',
            rentperStayedPeriod: '',
            totalDeduction: '',
            totalAmountRec: '',
            sdRefund: '',
            totalReceiveable: '',
            vacatingReason: '',
            remarks: '',
            glBalance: '',
            stayedRent: '',
            commReversal: '',
            calculatedDays: '',
            commReversal: '',
            manager: [],
            reasondrop: [],
            remarksDrop: [],
        })
        setTransectionDetails(null)
        setLeaseDetails([])
        setReceiptDetails([])
        setDeductionList([])
    }
    const handlePropertyChange = async (selectedOption) => {
        handleClearFilters()
        const params = new URLSearchParams();
        params.append('DropdownFor', 'TeminationCreateUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value?.value);
        const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items)
        setFormData({ ...formData, Proprty: selectedOption });
    }
    const handleUitNo = async (selectedOption) => {
        handleClearFilters()
        let selectedLease = leaseList.find((comp) => comp.value === selectedOption?.value?.value)
        setFormData({
            ...formData,
            unitNo: selectedOption,
            leaseNo: { label: selectedLease?.value, value: selectedLease },
        });
    }
    const handleLeaseChange = (selectedOption) => {
        handleClearFilters()
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
        });
        setFormData({ ...formData, leaseNo: selectedOption });
    }
    const handleSearch = async () => {
        try {
            if (!formData?.leaseNo?.label) {
                toast.warning("Please Select Lease No First")
                return;
            } else {
                const duductoinParam = new URLSearchParams();
                duductoinParam.append('Action', 'GetLeaseDeductionMaster');
                const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
                setDeductionList(deductionRes?.data?.result?.data)
                // get by lease NO
                const leasedetailParam = new URLSearchParams();
                leasedetailParam.append('Action', 'GetLeaseDetailsByLeaseNo');
                leasedetailParam.append('LeaseNo', formData?.leaseNo?.label);
                const leasedetailRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${leasedetailParam.toString()}`);
                setLeaseDetails(leasedetailRes?.data?.result?.data)

                const unitDetailsParam = new URLSearchParams();
                unitDetailsParam.append('Action', 'GetLeaseUnitDetailsByLeaseNo');
                unitDetailsParam.append('LeaseNo', formData?.leaseNo?.label);
                const unitDetailsRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${unitDetailsParam.toString()}`);
                if (unitDetailsRes?.data?.result?.data?.length > 0) {
                    setUnitDetails(unitDetailsRes?.data?.result?.data)
                } else {
                    setUnitDetails([unitDetailsRes?.data?.result?.data])
                }
                // get by lease NO
                const transectionParam = new URLSearchParams();
                transectionParam.append('Action', 'GetLeaseTransactionDetailsByLeaseNo');
                transectionParam.append('LeaseNo', formData?.leaseNo?.label);
                const transectionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${transectionParam.toString()}`);
                setTransectionDetails(transectionRes?.data?.result?.data)
                let transData = transectionRes?.data?.result?.data
                if (transData?.length !== 0) {
                    const SDparam = new URLSearchParams();
                    SDparam.append('Action', 'GetLeaseSecDepositByLeaseNo');
                    SDparam.append('LeaseNo', formData?.leaseNo?.label);
                    const sdRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${SDparam.toString()}`);
                    // get by lease NO
                    let securityDep = sdRes?.data?.result?.data?.SecDeposit || transData?.SecurityDeposit || 0
                    const receiptParam = new URLSearchParams();
                    // Get Receipt Details
                    receiptParam.append('Action', 'GetReceiptDetailsByLeaseNo');
                    receiptParam.append('LeaseNo', formData?.leaseNo?.label);
                    const receiptRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${receiptParam.toString()}`);
                    let receptdata = receiptRes?.data?.result?.data?.Amount ? [receiptRes?.data?.result?.data] : receiptRes?.data?.result?.data
                    const amount = receptdata?.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
                    setReceiptDetails(receptdata)
                    const invoiceParam = new URLSearchParams();
                    // Get Invoice Details
                    invoiceParam.append('Action', 'GetInvoiceDetailsByLeaseNo');
                    invoiceParam.append('LeaseNo', formData?.leaseNo?.label);
                    const InvoiceRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${invoiceParam.toString()}`);
                    let InvoiceData = InvoiceRes?.data?.result?.data?.Amount ? [InvoiceRes?.data?.result?.data] : InvoiceRes?.data?.result?.data
                    setInvoiceList(InvoiceData)
                    let selectedProperty = proprtyList.find((comp) => comp.value === transData?.Property_Id)
                    const params = new URLSearchParams();
                    // Get Unit List
                    params.append('DropdownFor', 'TeminationCreateUnitNosByPropertyId');
                    params.append('CascadValue', selectedProperty?.value);
                    const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
                    setUnitList(res?.data?.items)
                    let selectedUnit = res?.data?.items?.find((comp) => comp.text === transData?.Unit_No)

                    setFormData((prev) => ({
                        ...prev,
                        Proprty: { label: selectedProperty?.text, value: selectedProperty },
                        unitNo: { label: selectedUnit?.text, value: selectedUnit },
                        securityDeposit: securityDep?.toFixed(currencyPrecision?.decimalNumbers) || "0.000",
                    }));
                    let startDate = transData?.Lease_Date
                    let vocatingDate = transData?.Lease_Expiry
                    const toDate = formatDate(formattedDate);
                    const dayesstayed = calculateDaysBetween(startDate, formattedDate);
                    const rentDays = calculateDaysBetween(startDate, vocatingDate);
                    let totalDeduction = 0
                    if (dayesstayed > 0) {
                        let totalAmount = unitDetailsRes?.data?.result?.data?.Total || unitDetailsRes?.data?.result?.data[0]?.Total
                        let rentPerDay = (totalAmount / rentDays)
                        let rentperStayedPeriod = (rentPerDay * dayesstayed)
                        let totalAmountrec = amount || 0
                        let AmountBalance = (rentperStayedPeriod - totalAmountrec)
                        setTransectionData((prev) => ({
                            ...prev,
                            totalAmountRec: totalAmountrec,
                            dayesStayed: dayesstayed,
                            rentPerPeriod: transData?.TotalPrice?.toFixed(currencyPrecision?.decimalNumbers),
                            securityDeposit: securityDep?.toFixed(currencyPrecision?.decimalNumbers) || "0.000",
                            totalDeduction: "0.000",
                            sdRefund: "0.000",
                            rentAmtBalance: (transData?.MonthlyRent - amount)?.toFixed(currencyPrecision?.decimalNumbers),
                            rentPeriodUnchange: rentperStayedPeriod?.toFixed(currencyPrecision?.decimalNumbers),
                            AmountBalance: AmountBalance?.toFixed(currencyPrecision?.decimalNumbers),
                            monthRent: transData?.MonthlyRent?.toFixed(currencyPrecision?.decimalNumbers),
                            rentperStayedPeriod: rentperStayedPeriod?.toFixed(currencyPrecision?.decimalNumbers),
                            rentPerDay: rentPerDay?.toFixed(currencyPrecision?.decimalNumbers),
                            totalAmount: totalAmount?.toFixed(currencyPrecision?.decimalNumbers),
                        }));
                        let TotalDedcution = 0
                        handleSDRefund(securityDep, TotalDedcution, AmountBalance)
                    } else {
                        let totalAmount = unitDetailsRes?.data?.result?.data?.Total || unitDetailsRes?.data?.result?.data[0]?.Total
                        let rentPerDay = (totalAmount / rentDays)
                        let rentperStayedPeriod = 0
                        let totalAmountrec = amount || 0
                        let AmountBalance = 0
                        setTransectionData((prev) => ({
                            ...prev,
                            dayesStayed: dayesstayed,
                            totalAmountRec: totalAmountrec,
                            rentPerPeriod: transData?.TotalPrice?.toFixed(currencyPrecision?.decimalNumbers),
                            rentPeriodUnchange: rentperStayedPeriod?.toFixed(currencyPrecision?.decimalNumbers),
                            securityDeposit: securityDep?.toFixed(currencyPrecision?.decimalNumbers) || "0.000",
                            totalDeduction: "0.000",
                            sdRefund: "0.000",
                            rentAmtBalance: (transData?.MonthlyRent - amount)?.toFixed(currencyPrecision?.decimalNumbers),
                            AmountBalance: AmountBalance?.toFixed(currencyPrecision?.decimalNumbers),
                            monthRent: transData?.MonthlyRent?.toFixed(currencyPrecision?.decimalNumbers),
                            rentperStayedPeriod: rentperStayedPeriod?.toFixed(currencyPrecision?.decimalNumbers),
                            rentPerDay: rentPerDay?.toFixed(currencyPrecision?.decimalNumbers),
                            totalAmount: totalAmount?.toFixed(currencyPrecision?.decimalNumbers),
                        }));
                    }
                } else {
                    toast.error("No record in this lease No")
                }
            }
        } catch (error) {
            console.error('Error fetching  data:', error);
        }
    }
    const calculateDaysBetween = (startDate, vacatingDate) => {
        const diff = new Date(vacatingDate) - new Date(startDate);
        let leaseDate = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return leaseDate;
    }
    const handleSDRefund = async (Sd, TotalDedcution, RentBalance) => {
        let totalDeductions = parseFloat(TotalDedcution)
        let blnc = parseFloat(RentBalance)
        let Sds = parseFloat(Sd)
        // let total = (-(blnc + totalDeductions - Sds) || 0)
        let total = (-(blnc + totalDeductions - Sds) || 0)

        setTransectionData((prev) => ({
            ...prev,
            // sdRefund: (-Sd - TotalDedcution - RentBalance)?.toFixed(currencyPrecision?.decimalNumbers) || 0,
            totalpayable: total?.toFixed(currencyPrecision?.decimalNumbers) || 0,
        }));

    }
    const handleSave = async () => {
        try {
            setloader(true);
            if (!formData?.Proprty?.label) {
                toast.warning("Please Select Property")
                setloader(false)
                return
            } else if (!formData?.leaseNo?.label) {
                toast.warning("Please Select Lease No")
                setloader(false)
                return
            }
            const currentDatetimeUTC = new Date().toISOString();
            const deductionIndex = deductionList?.map((item, index) => {
                const selectedTax = taxList.find((t) => t.RecordId === parseInt(item.TaxCode));
                debugger
                return {
                    dmId: 0,
                    crAcCode: item?.AccountCode,
                    crAcName: item?.AccountName,
                    rate: parseFloat(item?.rate) || 0,
                    vat: parseFloat(item?.vat) || 0,
                    isRent: item?.fromRent || false,
                    modifiedBy: "0",
                    modifiedOn: currentDatetimeUTC,
                    createdBy: "0",
                    createdOn: currentDatetimeUTC,
                    financialYear: "string",
                    voucherNo: "0",
                    postingId: 0,
                    voucherSerialNo: "0",
                    postingType: "0",

                    isSelected: item?.Exp3 === "0" ? false : true,
                    recordId: item?.RecordId || 0,
                    description: item?.Description || "0",
                    posting: item?.Posting,
                    taxCode: item?.TaxCode.toString() || "0",
                    taxInclusive: item?.TaxInclusive,
                    vatAcCode: selectedTax?.VatAcCode || "0",
                    vatAcName: selectedTax?.Description || "0",
                    quantity: parseFloat(item?.qty) || 0,
                    totalAmount: parseFloat(item?.total) || 0,
                    remarks: item?.Remarks || "0",
                    amount: parseFloat(item?.amount) || 0
                };
            });
            let selectedProperty = proprtyList.find((comp) => comp.value === TransectionDetail?.Property_Id)
            let _LeaseTerminationDetails = {
                property_Id: TransectionDetail?.Property_Id,
                property_Name: selectedProperty?.text || "0",
                unit_No: TransectionDetail?.Unit_No,
                lease_No: TransectionDetail?.Lease_No,
                group_Id: TransectionDetail?.Group_Id.toString(),
                lease_Date: TransectionDetail?.Lease_Date,
                lease_Expiry: TransectionDetail?.Lease_Expiry,
                totalPrice: TransectionDetail?.TotalPrice.toString() || "0",
                cust1_No: TransectionDetail?.Cust1_No,
                cust1_Name: TransectionDetail?.Cust1_Name,
                contactNo: TransectionDetail?.MainContactNo,
                emailId: "0",
                passportId: "0",
                nationality: "0",
                vatRegNo: "0",
                leaseTerm: "0",
                noOfInstallment: "0",
                salesPerson: TransectionDetail?.SalesPerson,
                agent: TransectionDetail?.Agent || "0",
                rentTotal: parseFloat(transectionData?.rentPerPeriod),
                totalInvoiced: parseFloat(totalrent),
                receivedTotal: parseFloat(totalAmount),
                creditTotal: 0,
                transactionDate: moment(transectionData?.transDate).format(),
                noticeDate: moment(transectionData?.NoticeDate).format(),
                vacatingDate: moment(transectionData?.vacatingDate).format(),
                datePaidOnVacating: moment(transectionData?.vacationDate).format(),
                keyReturnDate: moment(transectionData?.returnDate).format(),
                actualLeaseAmount: parseFloat(transectionData?.rentPeriodUnchange),
                periodLeaseAmount: parseFloat(transectionData?.rentPerPeriod),
                rentForStayedPeriod: parseFloat(transectionData?.rentperStayedPeriod),
                cancellationCharges: 0,
                balance: parseFloat(transectionData?.sdRefund),
                totalDeduction: parseFloat(transectionData?.totalDeduction),
                balanceLeaseAmount: parseFloat(transectionData?.AmountBalance),
                rentAmountBalance: 0,
                deposit: parseFloat(transectionData?.securityDeposit),
                totalDeductions: parseFloat(transectionData?.totalDeduction),
                miscCharges: 0,
                totalReceivable: 0,
                reason: transectionData?.vacatingReason,
                remarks_Comments: transectionData?.remarks,
                waterReading: 0,
                wReadingDate: "1900-01-01T08:05:39.970Z",
                elecReading: 0,
                eReadingDate: "1900-01-01T08:05:39.970Z",
                inspectionComments: "0",
                refundLetterSent: false,
                forwordingAddress: "0",
                otherRemarks_Comments: "0",
                adminFee: 0,
                otherFee: 0,
                finalBill: "0",
                originalDepositReceipt: (transectionData?.rentPeriodUnchange).toString(),
                empowerFB: "0",
                damageReport: "0",
                rentPaid: "0",
                leaseStatus: "0",
                otherDue: "0",
                isApproved: false,
                approvedBy: "0",
                approvedOn: "1900-01-01T08:05:39.970Z",
                isApproved1: false,
                approvedBy1: "0",
                approvedOn1: "1900-01-01T08:05:39.970Z",
                remarks: transectionData?.remarks || "0",
                remarks1: transectionData?.vacatingReason || "0",
                remarks2: "0",
                inspectionComment: "0",
                waterMeterReading: "0",
                wmrDate: "1900-01-01T08:05:39.970Z",
                electricalMeterReading: "0",
                emrDate: "1900-01-01T08:05:39.970Z",
                gasMeterReading: "0",
                gmrDate: "1900-01-01T08:05:39.970Z",
                forwardingAddress: "0",
                voucherNo: "0",
                postingId: "0",
                voucherSerialNo: 0,
                postingType: "0",
                financialYear: activeFY?.label,
                exp1: transectionData?.totalAmountRec.toString() || "0.000",
                exp2: transectionData?.dayesStayed.toString() || "0",
                exp3: TransectionDetail?.LeaseTerm || "0",
                exp4: transectionData?.rentperStayedPeriod.toString() || "0.000",
                exp5: "0",
                exp6: "0",
                exp7: "0",
                exp8: "0",
                exp9: "0",
                exp10: "0"
            }
            const body = {
                leaseTerminationMain: {
                    _LeaseTerminationDetails: _LeaseTerminationDetails,
                    _LeaseDetailsIndex: {
                        recordId: UnitDetails[0]?.RecordId,
                        leaseNo: UnitDetails[0]?.LeaseNo,
                        groupId: UnitDetails[0]?.GroupId,
                        propertyNo: UnitDetails[0]?.PropertyNo,
                        propertyName: UnitDetails[0]?.PropertyName,
                        unitNo: UnitDetails[0]?.UnitNo,
                        rent: parseFloat(UnitDetails[0]?.Rent),
                        tax: UnitDetails[0]?.Tax,
                        vat: UnitDetails[0]?.VAT,
                        total: UnitDetails[0]?.Total,
                        unitType: UnitDetails[0]?.UnitType,
                        unitCategory: UnitDetails[0]?.UnitCategory
                    },
                    deductionIndex: deductionIndex,
                    _AttachmentIndex: {
                        recordId: 0,
                        description: "string",
                        imgPath: "string"
                    },
                    _InvoiceIndex: {
                        recordId: InvoiceList[0]?.RecordId,
                        groupId: InvoiceList[0]?.GroupId,
                        leaseNo: InvoiceList[0]?.LeaseNo,
                        category: InvoiceList[0]?.Category,
                        description: InvoiceList[0]?.Description,
                        dueDate: InvoiceList[0]?.DueDate,
                        invoiceNo: InvoiceList[0]?.InvoiceNo,
                        invoiceDate: InvoiceList[0]?.InvoiceDate,
                        installmentAmount: parseFloat(InvoiceList[0]?.InstallmentAmount),
                        tax: InvoiceList[0]?.Tax,
                        taxCode: InvoiceList[0]?.TaxCode,
                        taxInclusive: InvoiceList[0]?.TaxInclusive,
                        vatPercent: InvoiceList[0]?.VATPercent,
                        vat: InvoiceList[0]?.VAT,
                        total: InvoiceList[0]?.Total,
                        amountPaid: InvoiceList[0]?.AmountPaid,
                        balance: InvoiceList[0]?.Balance,
                        refNo: InvoiceList[0]?.RefNo,
                        narration: InvoiceList[0]?.Narration,
                        isSD: InvoiceList[0]?.IsSD,
                        isOther: InvoiceList[0]?.IsOther
                    },
                    _ReceiptIndex: {

                        recordId: receiptDetails[0]?.Record_Id,
                        leaseNo: TransectionDetail?.Lease_No,
                        groupId: 0,
                        psdId: 0,
                        description: receiptDetails[0]?.Description || "0",
                        receiptNo: receiptDetails[0]?.ReceiptNo || "0",
                        receiptDate: receiptDetails[0]?.PaymentDate || currentDatetimeUTC,
                        voucherNo: receiptDetails[0]?.VoucherNo || "0",
                        paymentMethod: receiptDetails[0]?.PaymentMethod || "0",
                        chequeNo: receiptDetails[0]?.ChequeNo || "0",
                        chequeDate: receiptDetails[0]?.ChequeDate || currentDatetimeUTC,
                        drawnOnBank: receiptDetails[0]?.DrawnOnBank || "0",
                        bankAccount: receiptDetails[0]?.Description || "0",
                        bankName: receiptDetails[0]?.Description || "0",
                        narration: "0",
                        isOther: false,
                        isSD: false,
                        isAdditionalAmount: false,
                        isOtherReceipt: false,
                        actualAmountPaid: parseFloat(receiptDetails[0]?.Amount || 0),
                        installmentAmount: 0,
                        vat: 0,
                        total: 0
                    },
                }
            };
            const postRes = await apiService.post('POST_LEASE_TERMINATION', body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(postRes?.data?.message);
                let resData = postRes?.data?.result
                const token = localStorage.getItem("Token");
                const DB = localStorage.getItem("DataBase")
                if (!token) {
                    alert("Auth token is missing! Unable to proceed.");
                    return;
                }
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;
                const popup = window.open(
                    "",
                    "ReportPopup",
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = REACT_APP_REPORTS
                    form.target = "ReportPopup";
                    const inputs = [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "LeaseNo", value: resData?.leaseNo },
                        { name: "reportName", value: 'LTER' },
                    ];

                    inputs.forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                setloader(false);
                navigate('/Property/Management/Lease/Termination/Listing')
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    return (
        <div className='p-5'>
            {/* Filters */}
            <div className='border-box2 p-2' style={{ borderRadius: "8px" }}>
                <div className='row'>
                    <div className='col-lg-8 mt-3' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                        <div className='d-flex'>
                            <Select
                                className="w-100 p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Proprty}
                                onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                            />
                        </div>
                        <div className='d-flex'>
                            <Select
                                className="w-100 p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.unitNo}
                                onChange={(selectedOption) => handleUitNo(selectedOption)}
                                options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                            />
                        </div>
                        <div className='d-flex'>
                            <WindowedSelect
                                className="w-100  p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                        color: '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',

                                            color: '#000',
                                        },
                                    }),
                                }}
                                options={
                                    leaseList
                                        ?.slice(0, 5000)
                                        .map(rec => ({ value: rec, label: rec?.value }))
                                }
                                value={formData.leaseNo}
                                onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                            />
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='d-flex gap-2'>
                            <div className='mainbtnGry flex-end gap-2 w-50' onClick={handleSearch}>
                                <IoSearch color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                            {loading === true ?
                                <div className='mainbtn flex-end gap-2 w-50'>
                                    <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                </div>
                                :
                                <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                                    <FaSave color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Save</div>
                                </div>
                            }
                        </div>
                        <div className='d-flex mt-1 gap-2'>
                            <div className='mainbtnSecondary flex-end gap-2 w-50' onClick={handleBackClick}>
                                <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Back</div>
                            </div>
                            <div className='mainbtnRed flex-end gap-2 w-50' onClick={handleClearFilters}>
                                <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Reset</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Lease Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Transaction Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)} >Deductions
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)} >Other Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 4 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(4)} >Invoices
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 5 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(5)} >Receipts
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<LeaseDetails leaseDetails={leaseDetails} UnitDetails={UnitDetails} />)}
            {gridVisibility[1] && (<TransectionDetails managerList={managerList} remarksList={remarksList} reasonList={reasonList} TransectionDetail={TransectionDetail} setTransectionData={setTransectionData} transectionData={transectionData}
                leaseDetails={leaseDetails} handleSDRefund={handleSDRefund}
                calculateDaysBetween={calculateDaysBetween} />)}
            {gridVisibility[2] && (<Deduction taxList={taxList} deductionList={deductionList} setDeductionList={setDeductionList} setTransectionData={setTransectionData} handleSDRefund={handleSDRefund} />)}
            {gridVisibility[3] && (<OtherDetails />)}
            {gridVisibility[4] && (<Invoices InvoiceList={InvoiceList} />)}
            {gridVisibility[5] && (<Receipts receiptDetails={receiptDetails} />)}

            <div className='d-flex justify-content-between boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Rent </div>
                    <div className='field'>{totalrent || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Invoiced</div>
                    <div className='field'>{totalrent || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Credit Note</div>
                    <div className='field'>{"0"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Received</div>
                    <div className='field'>{totalAmount || "---"}</div>
                </div>
            </div>
        </div>

    );
};
export default LeaseTermination;